import React from "react";
import InputField from "../../../../components/InputField";
import DocumentUpload from "../../../../components/DocumentUpload";
import "./index.scss";

const GSTEntries = ({
  isGSTRegistered,
  gstEntries,
  addGstEntry,
  removeGstEntry,
  handleGstChange,
  handleGstBlur,
  gstFiles,
  handleGstFileChange,
  gstErrors,
  existingGstFiles = [],
}) => {
  if (isGSTRegistered !== "yes") return null;

  return (
    <div className="gst-entries">
      {gstEntries.map((entry, index) => (
        <div key={index} className="gst-entry-row">
          <InputField
            name={`gstNumber_${index}`}
            label="GST Number"
            type="text"
            placeholder="e.g. 22AAAAA0000A1Z5"
            value={entry.gstNumber}
            maxLength={15}
            onChange={(e) =>
              handleGstChange(index, "gstNumber", e.target.value)
            }
            onBlur={() => handleGstBlur(index)}
            error={gstErrors[index] || ""}
          />
          <InputField
            name={`gstState_${index}`}
            label="State"
            type="text"
            placeholder="Auto-filled from GST number"
            value={entry.gstState}
            readOnly
          />
          <InputField
            name={`gstAddress_${index}`}
            label="GST Address"
            type="text"
            placeholder="Enter GST address"
            value={entry.gstAddress}
            onChange={(e) =>
              handleGstChange(index, "gstAddress", e.target.value)
            }
          />
          <DocumentUpload
            label="GST Certificate"
            name={`gstCertificate_${index}`}
            file={gstFiles[index]}
            existingFile={existingGstFiles[index] || null}
            onChange={(e) => handleGstFileChange(index, e.target.files[0])}
          />
          {gstEntries.length > 1 && (
            <button
              type="button"
              className="btn-remove-gst"
              onClick={() => removeGstEntry(index)}
            >
              ✕
            </button>
          )}
        </div>
      ))}
      <button type="button" className="btn-add-gst" onClick={addGstEntry}>
        + Add GST
      </button>
    </div>
  );
};

export default GSTEntries;
